module.exports = __webpack_public_path__ + "static/media/kaple-celek2.d4c0f789.jpg";